import React from "react";
import { useSelector } from "react-redux";
import { Translate } from "utils/translations/Translate";

import styles from "./Footer.module.scss";

function Footer() {
    const { lang } = useSelector((state) => state.translations);

    // initialize translate class
    const translation = new Translate("footerFactory", lang);
    const t = translation.getWord();

    return (
        <>
            <footer className={styles.footer}>
                <div className="container"></div>
            </footer>
        </>
    );
}

export default Footer;
